<div class="container">
  <app-mat-spinner-overlay [overlay]="true" *ngIf="loading"></app-mat-spinner-overlay>

  <!-- Breadcrumb -->
  <ul class="breadcrumb">
    <li><strong>Onde estou:</strong></li>
    <li class="active">
      <span>Cadastros/<b>Habilitação Mastercard Urbanos (Bacen)</b></span>
    </li>
  </ul>

  <!-- Status Header -->
  <div class="status-header">
    <div class="status-info">
      <span class="status-label">Status do processo:</span>
      <span class="status-badge" [ngClass]="{
        'badge-nao-iniciado': status === 'INI',
        'badge-preenchimento': status === 'PEN',
        'badge-submetido': status === 'ENV',
        'badge-ajuste': status === 'REJ',
        'badge-aprovado': status === 'APR'
      }">
        {{ statusLabel }}
      </span>
    </div>
    <div class="status-actions">

    </div>
  </div>

  <!-- Alert Banners -->
  <div class="alert-banner alert-sucesso" *ngIf="status === 'APR'">
    <mat-icon>check_circle</mat-icon>
    <div>
      <strong>Habilitação aprovada!</strong>
      <span *ngIf="dataLiberacao"> - Liberado em: {{ dataLiberacao }}</span>
    </div>
  </div>

  <div class="alert-banner alert-erro" *ngIf="status === 'REJ'">
    <mat-icon>error_outline</mat-icon>
    <div>
      <strong>Ajustes solicitados pela SWAP.</strong>
      <span *ngIf="mensagemSwap"> {{ mensagemSwap }}</span>
    </div>
  </div>

  <div class="alert-banner alert-info" *ngIf="status === 'ENV'">
    <mat-icon>hourglass_empty</mat-icon>
    <div>
      <strong>Dados enviados para a análise.</strong>
      <span> Aguardando retorno da SWAP.</span>
    </div>
  </div>
  <!-- Dados da empresa -->

  <div class="dados-empresa" *ngIf="empresa">
    <div class="row g-2">
      <div class="col-7">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Razão Social</mat-label>
          <input matInput [(ngModel)]="empresa.razaoSocial" name="razaoSocial" [disabled]="!isEditable"/>
        </mat-form-field>
      </div>

      <div class="col-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>CNPJ</mat-label>
          <input matInput [value]="empresa.cnpj | cpfCnpj" name="cnpj" [disabled]="true" />
        </mat-form-field>
      </div>
      <div class="col-2">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>ID do Cliente</mat-label>
          <input matInput [value]="empresa.codCliente || ''" name="codCliente" disabled="true" />
        </mat-form-field>
      </div>

      <div class="col-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Data de Fundação</mat-label>
          <input matInput [matDatepicker]="pickerFundacao" [(ngModel)]="empresa.dataFundacao" name="dataFundacao" [disabled]="!isEditable" />
          <mat-datepicker-toggle matSuffix [for]="pickerFundacao"></mat-datepicker-toggle>
          <mat-datepicker #pickerFundacao></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="col-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Data cadastro</mat-label>
          <input matInput [value]="empresa.dataCadastro | date:'dd/MM/yyyy'" name="dataCadastro" disabled  />
        </mat-form-field>
      </div>

      <div class="col-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Data Último Envio</mat-label>
          <input matInput [value]="empresa.dthUltimoEnvio | date:'dd/MM/yyyy HH:mm'" name="dthUltimoEnvio" disabled/>
        </mat-form-field>
      </div>
      <div class="col-12 tab-actions" *ngIf="isEditable">
        <button mat-flat-button class="btn-primario" type="button" (click)="submeterParaValidacao()">
          <mat-icon>save</mat-icon>
          Enviar Dados
        </button>
      </div>
    </div>
    <!-- ==================== TABS ==================== -->
    <div class="tabs-container">
      <mat-tab-group [(selectedIndex)]="selectedTabIndex" animationDuration="200ms">

        <!-- TAB 1: Sócios -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">people</mat-icon>
            Sócios
            <span class="tab-badge">{{ socios.length }}</span>
          </ng-template>

          <div class="tab-content">
            <!-- Action buttons -->
            <div class="tab-actions" *ngIf="isEditable">
              <button mat-flat-button class="btn-primario" type="button" (click)="cadastrarSocio()">
                <mat-icon>person_add</mat-icon>
                Cadastrar Sócio
              </button>
            </div>

            <!-- Tabela -->
            <table mat-table [dataSource]="dataSource" matSort class="w-100">
              <ng-container matColumnDef="dscNome">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
                <td mat-cell *matCellDef="let socio">{{ socio.dscNome }}</td>
              </ng-container>

              <ng-container matColumnDef="dscTipoPessoa">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
                <td mat-cell *matCellDef="let socio">{{ socio.dscTipoPessoa }}</td>
              </ng-container>

              <ng-container matColumnDef="numCpfCnpj">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>CPF/CNPJ</th>
                <td mat-cell *matCellDef="let socio">{{ socio.numCpfCnpj | cpfCnpj }}</td>
              </ng-container>

              <ng-container matColumnDef="datNascimento">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Data Nascimento/Fundação</th>
                <td mat-cell *matCellDef="let socio">{{ socio.dscTipoPessoa === 'CPF' ? (socio.datNascimento |
                  date:'dd/MM/yyyy') : (socio.datFundacao | date:'dd/MM/yyyy') }}</td>
              </ng-container>

              <ng-container matColumnDef="dscNomePai">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome do Pai</th>
                <td mat-cell *matCellDef="let socio">{{ socio.dscNomePai || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="dscNomeMae">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome da Mãe</th>
                <td mat-cell *matCellDef="let socio">{{ socio.dscNomeMae || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef>Ações</th>
                <td mat-cell *matCellDef="let socio">
                  <button mat-icon-button (click)="editarSocio(socio)" matTooltip="Editar sócio"
                    matTooltipPosition="left">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button (click)="removerSocio(socio)" matTooltip="Remover sócio"
                    matTooltipPosition="right">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="columns"></tr>
              <tr mat-row *matRowDef="let row; columns: columns;"></tr>

              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell no-data" [attr.colspan]="columns.length">
                  Nenhum sócio cadastrado. Clique em "Cadastrar Sócio" para começar.
                </td>
              </tr>
            </table>

            <mat-paginator [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons></mat-paginator>
          </div>
        </mat-tab>

        <!-- TAB 2: Histórico de Validação -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">history</mat-icon>
            Histórico
            <span class="tab-badge">{{ historico.length }}</span>
          </ng-template>

          <div class="tab-content">
            <div class="historico-timeline" *ngIf="historico.length > 0; else semHistorico">
              <div class="timeline-item" *ngFor="let item of historico; let last = last">
                <div class="timeline-marker" [ngClass]="{
                'marker-info': item.operacao=== 'CONSULT',
                'marker-sucesso': item.operacao=== 'INSERT',
                'marker-erro': item.operacao=== 'DELETE' || item.operacao=== 'DELETE',
                'marker-submissao': item.operacao=== 'UPDATE'
              }"></div>
                <div class="timeline-content" [class.timeline-last]="last">
                  <div class="timeline-header">
                    <span class="timeline-data">{{ item.dataFormatada }}</span>
                    <span class="timeline-tipo" [ngClass]="{
                    'tipo-info': item.operacao=== 'CONSULT',
                    'tipo-sucesso': item.operacao=== 'INSERT',
                    'tipo-erro': item.operacao=== 'DELETE' || item.operacao=== 'DELETE',
                    'tipo-submissao': item.operacao=== 'UPDATE'
                  }">{{ item.operacao}}</span>
                  </div>
                  <div class="timeline-descricao">{{ item.detalhe }}</div>
                  <div class="timeline-usuario" *ngIf="item.login">
                    <mat-icon>person_outline</mat-icon>
                    <span>{{ item.login }}</span>
                  </div>
                </div>
              </div>
            </div>

            <ng-template #semHistorico>
              <div class="empty-state">
                <mat-icon>schedule</mat-icon>
                <span>Nenhum registro no histórico ainda.</span>
              </div>
            </ng-template>
          </div>
        </mat-tab>

        <!-- TAB 3: Log de Auditoria -->
        <mat-tab *ngIf="false">
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">assignment</mat-icon>
            Log de Auditoria
            <span class="tab-badge">{{ logs.length }}</span>
          </ng-template>

          <div class="tab-content">
            <div class="log-lista" *ngIf="logs.length > 0; else semLogs">
              <div class="log-item" *ngFor="let log of logs">
                <div class="log-header">
                  <span class="log-data">{{ log.dataHora }}</span>
                  <span class="log-acao" [ngClass]="{
                  'acao-acesso': log.acao === 'ACESSO',
                  'acao-inclusao': log.acao === 'INCLUSAO',
                  'acao-alteracao': log.acao === 'ALTERACAO',
                  'acao-exclusao': log.acao === 'EXCLUSAO',
                  'acao-submissao': log.acao === 'SUBMISSAO',
                  'acao-status': log.acao === 'STATUS'
                }">{{ log.acao }}</span>
                </div>
                <div class="log-detalhe">{{ log.detalhe }}</div>
                <div class="log-usuario">
                  <mat-icon>person_outline</mat-icon>
                  <span>{{ log.usuario }}</span>
                </div>
              </div>
            </div>

            <ng-template #semLogs>
              <div class="empty-state">
                <mat-icon>assignment</mat-icon>
                <span>Nenhum log registrado.</span>
              </div>
            </ng-template>
          </div>
        </mat-tab>

      </mat-tab-group>
    </div>

    <!-- Scroll to top -->
    <div class="row mt-4 mb-3">
      <div class="col text-end">
        <button mat-stroked-button class="btn-cinza" (click)="scrollToTopAnimated()"
          matTooltip="Ir para o topo da página" matTooltipPosition="above" type="button">
          <mat-icon>vertical_align_top</mat-icon>
          Ir para o topo
        </button>
      </div>
    </div>
  </div>